import { RevShareComponents } from '@wix/package-picker-shared-studio';
import React from 'react';
import { BenefitFeatures } from '../BenefitFeatures/BenefitFeatures';

export const Subtitle = () => {
  return <RevShareComponents.Subtitle FallbackSubtitle={<BenefitFeatures />} />;
};
